import { render, staticRenderFns } from "./CounterCard.vue?vue&type=template&id=da1573d0"
import script from "./CounterCard.vue?vue&type=script&lang=js"
export * from "./CounterCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports